import React from 'react';
import UserAvatar from 'components/UserAvatar';


const UserSettingsAvatarsListLoading = () => {
  const loadingAvatarsIndexes = Array.from(Array(process.env.KOOTH_AVATAR_PAGE_SIZE).keys());

  return (
    <div>
      {loadingAvatarsIndexes.map(index => (
        <div className="option" key={index}>
          <UserAvatar size="large" isEmpty />
        </div>
      ))}
    </div>
  );
};

export default UserSettingsAvatarsListLoading;




/** WEBPACK FOOTER **
 ** ./src/members/Main/UserSettings/UserSettingsChangeAvatar/UserSettingsAvatarsListLoading/index.js
 **/